export default __webpack_public_path__ + "static/media/france_1.1c22e5e3.jpg";